import { TypePolicy } from '@apollo/client'

const ZoneZipcode: TypePolicy = {
  keyFields: ['zipCode'],
}

export default ZoneZipcode
